import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BottomSheetContentLayout, Column, RadioButtonWithLabel } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const GetMobileSortPickerTID = (parentTestId)=>getTestIds(parentTestId);
export const MobileSortPicker = (param)=>{
    let { testId, sortOptions, selectedSortOptionId, onSelect } = param;
    const { t: sortTexts } = useLocaleKeys('components.mobileFilterList');
    const { MobileSortPickerTID } = useMemo(()=>GetMobileSortPickerTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        header: {
            title: sortTexts.sortBy(),
            paddingBottom: 16
        },
        contentGutter: "m",
        children: /*#__PURE__*/ _jsx(Column, {
            gap: 16,
            children: sortOptions.map((option)=>/*#__PURE__*/ _jsx(RadioButtonWithLabel, {
                    testId: MobileSortPickerTID.SortOption(option.id),
                    label: option.label,
                    checked: option.id === selectedSortOptionId,
                    onChange: ()=>onSelect(option)
                }, option.id))
        })
    });
};
